import { FuelFlex } from '@frete.com/fuel-station-react'
import styled from 'styled-components'

export const Rounded = styled(FuelFlex)`
  border-radius: ${({ theme }) => theme.border.radius.circle};
  justify-content: center;
  align-items: center;
  width: 80px;
  height: 80px;
`
export const TextsWrapper = styled(FuelFlex)`
  text-align: center;
`
